<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '총원' },
        { type: 'text', label: '작업내용' },
        { type: 'time', label: '점검시간' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

    <!-- 점검대상 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('점검대상') }}</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-6 mt-6 gap-4">
        <div v-for="(target, target_i) in form.targets" :key="target.title">
          <span v-if="isPrint"> {{ target.title }} </span>
          <div class="flex flex-row items-center" v-else>
            <vs-checkbox
              v-model="target.isChecked"
              :readonly="board.readonly"
              @change="() => onChangeTarget(target_i)"
            >
              {{ target.title }}
            </vs-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- 정리정돈 -->
    <table-inspect
      v-if="form.targets[0].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="정리정돈"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList1"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList1', indexRows, text)
      "
    />

    <!-- 추락재해방지 -->
    <table-inspect
      v-if="form.targets[1].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="추락재해방지"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList2"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList2', indexRows, text)
      "
    />

    <!-- 끼임재해방지 -->
    <table-inspect
      v-if="form.targets[2].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="끼임재해방지"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList3"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList3', indexRows, text)
      "
    />
    <!-- 보호구 -->
    <table-inspect
      v-if="form.targets[3].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="보호구"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList4"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList4', indexRows, text)
      "
    />
    <!-- 작업자건강 -->
    <table-inspect
      v-if="form.targets[4].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="작업자건강"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList5"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList5', indexRows, text)
      "
    />
    <!-- 근골격계질환 -->
    <table-inspect
      v-if="form.targets[5].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="근골격계질환"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList6"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList6', indexRows, text)
      "
    />
    <!-- 안전보건교육 -->
    <table-inspect
      v-if="form.targets[6].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="안전보건교육"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList7"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList7', indexRows, text)
      "
    />
    <!-- 표지 -->
    <table-inspect
      v-if="form.targets[7].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="표지"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList8"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList8', indexRows, text)
      "
    />
    <!-- 기타 -->
    <table-inspect
      v-if="form.targets[8].isChecked"
      class="mt-8"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="기타"
      tableHeaderTitle="착안사항"
      tableHeaderYes="양호"
      tableHeaderNo="미흡"
      tableHeaderNa="해당없음"
      :is-show-title="true"
      :list="form.inspectList9"
      @update-list-check="
        (indexRows, text) => updateListCheck('inspectList9', indexRows, text)
      "
    />

    <!-- 현장근로자 의견 청취 및 특이사항 -->
    <div class="grid grid-cols-12 gap-x-6">
      <vs-row class="mt-8 col-span-12">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('현장근로자 의견 청취 및 특이사항') }}</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-4 flex items-center mt-4">
        <div class="label-text mr-4">{{ $t('현장근로자 의견 청취') }}</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputA_1.fileName }}
        </p>
        <file-uploader
          v-else
          :readonly="board.readonly"
          v-model="form.inputA_1"
          class="flex-1 w-full"
        />

      </div>
      <div class="col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">{{ $t('특이사항') }}</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputA_2 }} </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputA_2"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!-- 기타 현장의 특수성 정리 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('기타 현장의 특수성 정리') }}</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('점검자') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_1"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('직책') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_2"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('부서(업체)명') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_3"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
      </div>

      <div class="col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">{{ $t('내용') }}</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputB_4 }} </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_4"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      section-title="사진대지"
      :is-print="isPrint"
      :readonly="board.readonly"
      placeholder="00센터 신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspect";
import FileUploader from "@/components/FileUploader";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    FileUploader,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        targets: [
          { title: "정리정돈", isChecked: false },
          { title: "추락재해방지", isChecked: false },
          { title: "끼임재해방지", isChecked: false },
          { title: "보호구", isChecked: false },
          { title: "작업자건강", isChecked: false },
          { title: "근골격계질환", isChecked: false },
          { title: "안전보건교육", isChecked: false },
          { title: "표지", isChecked: false },
          { title: "기타", isChecked: false },
        ],
        inspectList1: [
          {
            id: 1,
            label: "1. 작업장의 정리정돈 상태는?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 공구 및 기계의 정비 및 정리정돈 상태는?",
            is_checked: "",
          },
        ],
        inspectList2: [
          {
            id: 1,
            label: "1. 추락위험이 있는 장소에 작업발판이 설치되어 있는가?",
            is_checked: "",
          },
          {
            id: 2,
            label:
              "2. 바닥면에서 높이 1m이상인 계단의 개방된 측면에 안전난간이 설치되어 있는가?",
            is_checked: "",
          },
          {
            id: 3,
            label:
              "3. 작업발판, 안전난간이나 개구부덮개를 설치한 경우 충분한 강도를 가진 재료로 견고하게 설치되어 있는가?",
            is_checked: "",
          },
          {
            id: 4,
            label:
              "4. 안전난간 부착이 곤란한 경우 추락방호망 또는 안전대 부착설비가 설치되어 있는가?",
            is_checked: "",
          },
          {
            id: 5,
            label:
              "5. 안전대 부착설비를 설치한 경우, 안전대 및 부착설비의 이상(처짐, 풀림 등)유무를 작업시작 전 점검하는가?",
            is_checked: "",
          },
        ],
        inspectList3: [
          {
            id: 1,
            label:
              "1. 위험기계기구에 적합한 방호장치를 설치하고 있으며, 안전인증·안전검사 대상인 경우 인증 또는 검사를 받고 사용하고 있는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 위험기계기구의 방호조치 등의 기능이 유지되고 있는가?",
            is_checked: "",
          },
          {
            id: 3,
            label:
              "3. 기계기구 또는 설비에 설치한 방호장치를 임의해체하거나 기능을 해제한 상태로 사용하는가?",
            is_checked: "",
          },
          {
            id: 4,
            label:
              "4. 끼임 위험이 있는 원동기, 회전축, 기어 및 체인에 대한 방호장치의 유무 및 유지관리 여부",
            is_checked: "",
          },
          {
            id: 5,
            label:
              "5. 동력으로 작동되는 기계에 스위치, 클러치, 벨트이동장치 등 동력차단장치 설치 유무",
            is_checked: "",
          },
          {
            id: 6,
            label:
              "6. 사용 중인 기계·기구 또는 설비에 대한 정비 등 작업시 [운전정지→스위치 잠금→조작금지 표지판 설치]의 절차를 따르고 있는가?",
            is_checked: "",
          },
        ],
        inspectList4: [
          {
            id: 1,
            label: "1. 적절한 보호구는 지급하고 있는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 적절한 보호구는 착용하고 있는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 보호구는 주기적인 점검 및 교체 여부",
            is_checked: "",
          },
        ],
        inspectList5: [
          {
            id: 1,
            label: "1. 작업자의 건강상태는?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 근로자들의 건강검진은 지켜지고 있는가?",
            is_checked: "",
          },
        ],
        inspectList6: [
          {
            id: 1,
            label:
              "1. 하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
            is_checked: "",
          },
          {
            id: 2,
            label:
              "2. 하루 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세의 작업에 해당이 되는가?",
            is_checked: "",
          },
          {
            id: 3,
            label:
              "3. 하루 총 2시간 이상 4.5kg이상의 물건을 한 손으로 들거나 동일한 힘으로 쥐는 작업에 해당이 되는가?",
            is_checked: "",
          },
          {
            id: 4,
            label:
              "4. 5kg이상 중량물 취급 시 중량물 취급안내표시가 부착되어있는가?",
            is_checked: "",
          },
        ],
        inspectList7: [
          {
            id: 1,
            label: "1. 정기안전보건교육은 규정대로 실시하고 있는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 신규채용자의 안전보건교육은 별도로 실시하였는가?",
            is_checked: "",
          },
        ],
        inspectList8: [
          {
            id: 1,
            label: "1. 안전보건표지는 적절히 부착되어 있는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 산업안전보건법령요지는 눈에 띄는 곳에 게시되어 있는가?",
            is_checked: "",
          },
          {
            id: 3,
            label:
              "3. 화학물질 취급시 MSDS 게시 및 부착의무는 지켜지고 있는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 화학물질 취급시 작업 공정별 관리요령이 게시되어 있는가?",
            is_checked: "",
          },
        ],
        inspectList9: [
          {
            id: 1,
            label: "1. 서류는 보존기간을 지켜 보존하고 있는가?",
            is_checked: "",
          },
        ],
        photoList: [],
        fileList: [],

        inputA_1: {},
        inputA_2: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
      },
    };
  },
  methods: {
    onChangeTarget(/*index*/) {
      // this.form.targets = this.form.targets.map((target, target_i) => {
      //   if (index !== target_i) return { ...target, isChecked: false };
      //   else return target;
      // });
    },
    updateListCheck(list, indexRows, text) {
      this.form[list][indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
